
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import Breadcrumbs from "./components/base/Breadcrumbs";
import ScrollToTop from "./components/feature/ScrollToTop";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Breadcrumbs />
      <AppRoutes />
      <ScrollToTop />
    </BrowserRouter>
  );
}

export default App;
